import { render, staticRenderFns } from "./HsaBankOnboardingFooter.vue?vue&type=template&id=0c5a3b5f"
import script from "./HsaBankOnboardingFooter.vue?vue&type=script&lang=ts"
export * from "./HsaBankOnboardingFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports